import React from "react";
import {connect} from "react-redux";
import I18n from 'lib/i18n/i18n';
import {
    MediumSecondaryButton
} from '@worthy-npm/clarity';
import WorthyApi from 'lib/api/worthyApi';
import moment from "moment";
import UserActions from "lib/userActions";

class ListingReminder extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            step: 1
        };

        moment.updateLocale('en', {
            calendar: {
                nextDay: '[Tomorrow]',
                nextWeek: 'on dddd, MMMM Do, YYYY',
                sameElse: 'on dddd, MMMM Do, YYYY'
            }
        });
    }

    optionSelected = (days, text) => {
        const {item, version, Session} = this.props
        UserActions.listingPage(`'${text}' clicked`, item.id, version)
        const localTime = Session.userData.local_time;
        if (localTime) {
            WorthyApi.scheduleListingReminder(item.id, days)
                .then(res => {
                    const reminderTime = moment(localTime).add(days, 'days')
                    const displayReminderTime = reminderTime.calendar()
                    this.setState({step: 2, runAt: displayReminderTime, showAnimation: true});
                }).catch(e => console.error(e));
        }
    }

    render() {
        const { step, runAt, showAnimation } = this.state;
        const reminderDaysOptions = [1, 7, 14];
        return (
            <div className={`remind-later ${showAnimation ? 'animation' : null}`}>
                <h3>{ I18n.getString(`listingPage::remindLater::popup${step}::title`) }</h3>
                <div className={'reminder-content'}>
                    <div className={'description'}>{I18n.getString(`listingPage::remindLater::popup${step}::description`, {itemType: this.props.item.item_type, remindAt: runAt})}</div>
                    {
                        step === 1 ?
                            reminderDaysOptions.map((d, i) => {
                                return this.renderButton(d, i)
                            })
                        : null
                    }
                </div>
            </div>
        )
    }

    renderButton = (days, i) => {
        const { step } = this.state;
        const text = I18n.getString(`listingPage::remindLater::popup${step}::remindInDays::${days}`);
        return (
            <div key={i} className={'reminder-button'}>
                <MediumSecondaryButton
                    text={text}
                    disabled={false}
                    click={ () => {this.optionSelected(days, text)}}
                />
            </div>
        )
    }
}

const mapStateToProps = ({ Item, Session }) => {
    return {
        item: Item,
        Session
    };
};

export default connect(mapStateToProps)(ListingReminder);
